import * as yup from "yup";

export const CommentFormValidationSchemaFields = {
    comment: yup.string().required("Please write a comment"),
};

export type CommentFormValues = {
    comment: string;
};
